import { render, staticRenderFns } from "./LbaCKEditor.vue?vue&type=template&id=52bd55cc"
import script from "./LbaCKEditor.vue?vue&type=script&lang=js"
export * from "./LbaCKEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports